<!-- Dialog title -->
<h1 mat-dialog-title>
  <div class="flex flex-row items-center">
    <mat-icon class="icon-size-8 pe-2" svgIcon="mat_solid:content_copy"></mat-icon>
    {{ 'Adjust BIM Orientation' | transloco }}
  </div>
</h1>
<mat-divider class="py-2"></mat-divider>

<!-- Dialog content -->
<div
  mat-dialog-content
  class="flex flex-col min-h-42 overflow-hidden text-secondary gap-4"
  style="height: 100%; overflow: auto"
>
  <p>{{ 'Do you want to save the new orientation?' | transloco }}</p>
  <mat-checkbox (change)="is_checked = !is_checked" [checked]="is_checked" color="primary">
    <span>{{ 'Apply to all reports' | transloco }}</span>
  </mat-checkbox>
</div>

<div mat-dialog-actions class="flx-row justify-end">
  <!-- Cancel button -->
  <button mat-button (click)="onNoClick()">{{ 'Cancel' | transloco }}</button>
  <!-- Add button -->
  <button mat-raised-button color="primary" (click)="onSave()" cdkFocusInitial>
    {{ 'Save' | transloco }}
  </button>
</div>
